import { useTranslation } from '@/contexts/i18n-context';
import { NavigationStepper } from './navigation-stepper';
import { useProfileCreation } from '@/contexts/profile-creation-context';

export function ProfileCreationNavigation() {
  const { steps } = useProfileCreation();

  const { t } = useTranslation();

  return <NavigationStepper title={t('navigators.profileCreation.title')} steps={steps} />;
}
